
import { defineComponent, nextTick, provide, computed } from 'vue'
import { INTRODUCTION_CONFIG } from '@/config'
import { useQuestion, useSwipeRefs } from '@/hooks'

const join = (link: string) => {
  window.open(link, '_blank')
}

export default defineComponent({
  name: 'Home',
  setup () {
    provide('join', join)
    const { groupList, resultList, questionList, initResults, reset } = useQuestion()
    const { swipe, swipeIndex, resultSwipe, setIndex, update, next, jump } = useSwipeRefs()

    // 是否允许手势翻页
    const allowTouchMove = computed(
      () => !(swipeIndex.value === 11 && resultList.value.length)
    )
    // 部门详情是否显示"返回推荐列表"
    const showBackResultBtn = computed(
      () => resultList.value.length && (swipe.value.prevIndex === questionList.length + 1)
    )

    // 翻页结束事件
    const onSwipeChange = (index: number) => {
      setIndex(index)
      if (index === questionList.length) reset()
    }
    // 获取推荐列表
    const onQuestionComplete = () => {
      initResults()
      nextTick(() => {
        if (resultList.value.length) update()
        next()
      })
    }
    // 跳转到详情
    const jumpDetail = (qq: number) => {
      // console.log('qq:', qq)
      let index = groupList.findIndex(item => item.qq === qq) + 1
      index += 1 // 首屏
      index += questionList.length // 问卷页数
      if (resultList.value.length) index += 1 // 结果页
      // console.log(index) // 实际跳转的index
      jump(index)
    }
    // 跳转到推荐结果
    const jumpResults = () => {
      if (!resultList.value.length) return false
      jump(questionList.length + 1)
    }
    // 跳转到部门列表
    const jumpGroups = () => {
      let index = questionList.length + 1
      if (resultList.value.length) index++
      jump(index)
    }
    return {
      swipe,
      resultSwipe,
      INTRODUCTION_CONFIG,
      questionList,
      groupList,
      resultList,
      onSwipeChange,
      onQuestionComplete,
      jumpDetail,
      jumpResults,
      jumpGroups,
      allowTouchMove,
      join,
      showBackResultBtn
    }
  }
})

